import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { ConfigLicensing } from "../licensing/licensing.js";
const OptionsPage = observer(()=>{
    const { optionStore: { others: { showLicenseFormImmediate } } } = useStores();
    if (showLicenseFormImmediate) {
        return /*#__PURE__*/ _jsx(ConfigLicensing, {});
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "wp-heading-inline",
                style: {
                    marginBottom: 10
                },
                children: __("Media Folders")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                style: {
                    marginBottom: 15
                },
                children: __("Configure Real Media Library settings below. Use the tabs to switch between option groups.")
            })
        ]
    });
});
export { OptionsPage };
